import axios from 'axios';
import { get } from 'svelte/store';
import config from '../stores/config'
import * as ls from "local-storage";

const loadData = async (force = true) => {
  return new Promise(async (resolve, reject) => {

    if (get(config)?.currentUser?.username == undefined || force) {
      try {
        let authData = {
          headers: {
            authorization: ls.get("jwt"),
          },
        };

        const response = await Promise.all([
          axios.get(`${get(config).backendURL}/me`, authData),
          axios.get(`${get(config).backendURL}/suppliers/names`),
          axios.get(`${get(config).backendURL}/customers/names`),
          axios.get(`${get(config).backendURL}/items/names`),
          axios.get(`${get(config).backendURL}/fstyles/names`),
          axios.get(`${get(config).backendURL}/items/k`),
        ]);

        // If he was not found in the session, login first
        if (response[0].data.error) window.location = "/#/login";

        config.update((prev) => ({
          ...prev,
          currentUser: response[0].data,
          suppliers: response[1].data,
          customers: response[2].data,
          items: response[3].data,
          fstyles: response[4].data,
          K: response[5].data,
        }));

        console.log("💡 New data saved");

        resolve({ loading: false });
      } catch (err) {
        console.log(err);
        window.location = "/#/login";
        window.location.reload();
        resolve({ loading: false, loggedIn: false });
      }
    } else {
      resolve({ loading: false });
    }

    // After we have loaded the data
    if (!get(config).currentUser.username) {
      window.location = "/#/login";
      window.location.reload();
      resolve({ loading: false, loggedIn: false });
    }
  });
}

export default loadData;